import { render, staticRenderFns } from "./SafetyView.vue?vue&type=template&id=873ed37e&scoped=true"
import script from "./SafetyView.vue?vue&type=script&setup=true&lang=js"
export * from "./SafetyView.vue?vue&type=script&setup=true&lang=js"
import style0 from "./SafetyView.vue?vue&type=style&index=0&id=873ed37e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "873ed37e",
  null
  
)

export default component.exports